import myAxios from './myAxios';

export {
    getDistributor,
    addLicense,
    getIssuedLicenses
};

function getDistributor() {
    return myAxios.get('/api/distributors/me');
}

function addLicense({ email, prodid, exp, devnum }) {
    return myAxios.post('/api/distributors/addlicense', { email, prodid, exp, devnum });
}

function getIssuedLicenses(prodid) {
    return myAxios.get('/api/distributors/issuedLicenses', { params: { prodid } });
}
